import Bridge from "@/utils/bridge";
import Vant from "vant";
import "vant/lib/index.css";
import Vue from "vue";
import App from "./App.vue";
import "./assets/styles/base.scss";

// 兼容es6
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'url-search-params-polyfill';


// 全局组件引入
import SharePop from "@/components/SharePop"; // 浏览器打开全局弹窗组件
import CountTo from "vue-count-to";

// 全局方法引入
import { numberFormat } from "@/utils/function";

import router from "./router";
import store from "./store";
import mixin from "@/utils/mixin";
import "@/utils/rem";
import VConsole from 'vconsole';

// 全局组件挂载
Vue.component("CountTo", CountTo);
Vue.component("SharePop", SharePop);

// 全局方法挂载
Vue.prototype.numberFormat = numberFormat;

Vue.config.productionTip = false;
const urlParams = new URLSearchParams(window.location.search);
console.log('渠道号',urlParams.get('source'));
if (urlParams.get('source') && urlParams.get('source') == 'ceshi002') {
  var vConsole = new VConsole();
}
Vue.use(Vant);
Vue.mixin(mixin);

// H5 与客户端交互统一使用现有 Bridge，不再加载已下线的 uni webview SDK。
Vue.prototype.$bridge = Bridge;

import VueAwesomeSwiper from 'vue-awesome-swiper';
import'swiper/css/swiper.css'; // 引入 Swiper 样式

Vue.use(VueAwesomeSwiper);


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// 加入百度统计
router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(["_trackPageview", "/#" + to.fullPath]);
    }
  }
  next();
});
